module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/01-97af31d3e3024f62032ec0e69b0022e4.jpg";